<ng-container *ngIf="allowed === 'true'; else noCashOutAllowedContainer">
  <h3 class="mg-step-header">
    {{
      flow === "withdraw"
        ? estimateLabels.header.withdraw
        : estimateLabels.header.deposit
    }}
  </h3>
  <p class="mg-step-subheader" *ngIf="flow === 'deposit'">
    {{ estimateLabels.subheader }}
  </p>
  <form
    novalidate
    class="estimate-form"
    *ngIf="form"
    [formGroup]="form"
    (ngSubmit)="submitted.emit(formatSubmitValue(value))"
  >
    <mat-form-field class="country-form-field">
      <mat-label>
        {{
          flow === "withdraw"
            ? estimateLabels.cashOutCountry
            : estimateLabels.cashInCountry
        }}
      </mat-label>
      <ng-container
        *ngIf="
          flow === 'withdraw' || !disableCashInCountry;
          else depositCountrySelect
        "
      >
        <input
          id="selectedCountry"
          type="text"
          [attr.aria-label]="estimateLabels?.cashOutCountry"
          matInput
          formControlName="country"
          [matAutocomplete]="auto"
        />
        <mat-icon class="arrow-icon" matSuffix>{{ countryArrowIcon }}</mat-icon>
        <mat-autocomplete
          [displayWith]="
            getSelectedOptionLabel.bind(this, countriesFromStore, 'code')
          "
          (opened)="countryArrowIcon = 'keyboard_arrow_up'"
          (closed)="countryArrowIcon = 'keyboard_arrow_down'"
          #auto="matAutocomplete"
          #selectedCountry="matAutocomplete"
        >
          <mat-option
            *ngFor="let option of filteredCountries | async"
            [value]="option.name"
          >
            {{ option.name }}
          </mat-option>
        </mat-autocomplete>
      </ng-container>
      <ng-template #depositCountrySelect>
        <mat-select formControlName="country">
          <mat-option
            *ngFor="let countryOpt of countries"
            [value]="countryOpt.code"
          >
            {{ _countryName }}
          </mat-option>
        </mat-select>
      </ng-template>
      <mat-error>
        <ng-container *ngIf="form.get('country')?.errors?.required">
          {{ labels.stellar.error.countryRequired }}
        </ng-container>
        <ng-container
          *ngIf="
            !form.get('country')?.errors?.required &&
            form!.get('country')?.errors?.invalidOption &&
            (form.get('country')?.touched || form.get('country')?.dirty)
          "
        >
          {{ labels?.stellar?.countryNotFound }}
        </ng-container>
        <ng-container
          *ngIf="
            !form.get('country')?.errors?.required &&
            !form!.get('country')?.errors?.invalidOption &&
            form!.get('country')?.errors?.notSupported &&
            (form.get('country')?.touched || form.get('country')?.dirty)
          "
        >
          <!-- ToDo: will remove hardcoded values, once CMS translations available -->
          {{ labels?.stellar?.countryNotSupported }}
        </ng-container>
      </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="states && states.length > 0 && flow === 'withdraw'">
      <mat-label>
        {{
          flow === "withdraw"
            ? estimateLabels?.cashOutState
            : estimateLabels?.cashInState
        }}
      </mat-label>
      <input
        id="selectedState"
        type="text"
        [attr.aria-label]="estimateLabels?.cashOutState"
        matInput
        [formControl]="stateControl"
        [matAutocomplete]="auto"
      />
      <mat-icon class="state-arrow-icon" matSuffix>{{
        stateArrowIcon
      }}</mat-icon>
      <mat-autocomplete
        #auto="matAutocomplete"
        #selectedState="matAutocomplete"
        [displayWith]="getSelectedOptionLabel.bind(this, states, 'code')"
        (opened)="statePanelToggle(true)"
        (closed)="statePanelToggle(false)"
      >
        <mat-option
          [value]="state.name"
          *ngFor="let state of filteredOptions | async"
        >
          {{ state.name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error>
        <ng-container *ngIf="form!.get('state')?.errors?.required">
          {{ labels.stellar.error.stateRequired }}
        </ng-container>
      </mat-error>
      <mat-error
        *ngIf="
          !form!.get('state')?.errors?.required &&
          form!.get('state')?.errors?.invalidOption
        "
        >{{ labels?.stellar?.stateNotFound }}!</mat-error
      >
    </mat-form-field>

    <div class="currency-amount">
      <mat-form-field>
        <mat-label>
          {{ estimateLabels.amount }}
        </mat-label>
        <input
          matInput
          type="number"
          min="0"
          formControlName="amount"
          (blur)="formatAmount()"
        />
        <mat-error>
          <ng-container *ngIf="form.get('amount')?.errors?.required">
            {{ labels.stellar.error.amountRequired }}.
          </ng-container>
          <ng-container *ngIf="form.get('amount')?.errors?.min">
            {{ labels.stellar.error.invalidAmount }}
          </ng-container>
        </mat-error>
      </mat-form-field>
      <div matSuffix *ngIf="iso2Code" class="currency-amount-suffix">
        <span class="mat-h4">USDC</span>
        <div class="glob-flag flag"></div>
      </div>
    </div>

    <div class="currency-exchange">
      <label class="currency-label">
        {{ labels?.stellar?.estimate?.exchangeCurrency }}
        <sup *ngIf="flow === 'deposit' && indicativeRateCountry">{{ 1 }}</sup>
        <sup
          *ngIf="
            flow === 'withdraw' && labels?.stellar?.estimate?.currecyFootNote
          "
          ><span>&#42;</span></sup
        >
      </label>
      <div matSuffix *ngIf="iso2Code" class="currency-suffix multi-currency">
        <span class="mat-h4">{{ receiveCurrency }}</span>
        <mat-menu #appMenu="matMenu">
          <button
            *ngFor="let rc of receiveCurrencies"
            class="mat-menu-item"
            (click)="changeCurrency(rc)"
          >
            {{ rc }}
          </button>
        </mat-menu>
        <span mat-icon-button [matMenuTriggerFor]="appMenu"
          ><i
            *ngIf="receiveCurrencies && receiveCurrencies.length > 1"
            class="material-icons"
            >expand_more</i
          ></span
        >
      </div>
    </div>

    <app-indicative-rate-note></app-indicative-rate-note>

    <div class="mg-step-actions-row">
      <ng-container *ngIf="flow === 'withdraw'">
        <app-moneygram-locations-link
          [google]="google"
          [kind]="flow"
          [labels]="labels"
          [displaySuperscript]="!indicativeRateCountry"
        ></app-moneygram-locations-link>
        <app-walmart-footnote
          *ngIf="!indicativeRateCountry"
          [labels]="labels"
        ></app-walmart-footnote>
        <div
          class="footnote-container"
          *ngIf="labels?.stellar?.estimate?.currecyFootNote"
        >
          <span>&#42;</span> {{ labels?.stellar?.estimate?.currecyFootNote }}
        </div>
      </ng-container>
      <button
        color="primary"
        mat-raised-button
        type="submit"
        [disabled]="form.invalid"
      >
        {{ labels.stellar.next }}
      </button>
    </div>
  </form>
</ng-container>
<ng-template #noCashOutAllowedContainer>
  <div class="no-cash-out-allowed">
    <p>{{ estimateLabels.noCashOutAllowed }} {{ _countryName }}</p>
  </div>
  <div class="mg-step-actions-row">
    <button
      color="primary"
      mat-raised-button
      type="submit"
      (click)="backToWalletDone()"
    >
      {{ estimateLabels.returnToWallet }}
    </button>
  </div>
</ng-template>
